import { useEffect } from "react";

import { matchPath, useLocation } from "react-router-dom";

import { AnalyticsPages, AnalyticsService } from "utils/analytics";

const PAGE_ANALYTICS: Array<{ pattern: string; name: string }> = [
  { pattern: "/dashboard/*", name: AnalyticsPages.DASHBOARD },
  { pattern: "/calendar/*", name: AnalyticsPages.CALENDAR },
  { pattern: "/messages/*", name: AnalyticsPages.MESSAGES },
  { pattern: "/settings/*", name: AnalyticsPages.SETTINGS },
  { pattern: "/library/*", name: AnalyticsPages.LIBRARY.ROOT },
  { pattern: "/wiki/*", name: AnalyticsPages.WIKI },
  { pattern: "/admin-billing/*", name: AnalyticsPages.ADMIN_BILLING },
  { pattern: "/admin/*", name: AnalyticsPages.ADMIN },
  { pattern: "/invitations/*", name: AnalyticsPages.INVITATIONS },
  { pattern: "/login/bankid", name: AnalyticsPages.LOGIN.BANK_ID },
  { pattern: "/login/*", name: AnalyticsPages.LOGIN.EMAIL },
  { pattern: "/signup/*", name: AnalyticsPages.SIGNUP.EMAIL },
  // Patient list
  { pattern: "/patients", name: AnalyticsPages.PATIENTS.PATIENTS_LIST },
  // Patient profile information sub-pages (most specific first)
  { pattern: "/patients/:id/information/journal", name: AnalyticsPages.PATIENTS.INFORMATION.MEDICAL_RECORD },
  {
    pattern: "/patients/:id/information/sign-up-questions",
    name: AnalyticsPages.PATIENTS.INFORMATION.SIGN_UP_QUESTIONS,
  },
  { pattern: "/patients/:id/information/goals", name: AnalyticsPages.PATIENTS.INFORMATION.GOAL },
  { pattern: "/patients/:id/information/personal", name: AnalyticsPages.PATIENTS.INFORMATION.PERSONAL_DETAILS },
  {
    pattern: "/patients/:id/information/health-reports",
    name: AnalyticsPages.PATIENTS.INFORMATION.HEALTH_QUESTIONNAIRES,
  },
  // Patient profile sub-pages
  { pattern: "/patients/:id/overview", name: AnalyticsPages.PATIENTS.OVERVIEW },
  { pattern: "/patients/:id/messages", name: AnalyticsPages.PATIENTS.MESSAGES },
  { pattern: "/patients/:id/comments", name: AnalyticsPages.PATIENTS.COMMENTS },
  { pattern: "/patients/:id/protocol/*", name: AnalyticsPages.PATIENTS.PROTOCOL },
];

export const PageViewTracker: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const match = PAGE_ANALYTICS.find(({ pattern }) => matchPath(pattern, pathname));
    if (match) {
      AnalyticsService.viewedPage(match.name, pathname);
    }
  }, [pathname]);

  return null;
};
